import {
  useIsDashboardEditable,
  useUpsertDashboard,
} from '@modules/dashboard/hooks';
import { DashboardActionType } from '@modules/dashboard/store/dashboardActionType';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { DashboardAnalysisMetadataInput } from 'generated/graphql';
import { useCallback } from 'react';

export const useUpdateDashboardBarLabelWidthMetadata = () => {
  const dispatch = useDashboardStore(({ dispatch }) => dispatch);
  const analysesMetadata = useDashboardStore(
    ({ metadata }) => metadata.analysesMetadata,
  );

  const { upsertDashboard } = useUpsertDashboard();

  const isEditable = useIsDashboardEditable();

  const updateBarLabelWidthMetadata = useCallback(
    async (analysisID: string, barLabelWidthPercentage: number) => {
      if (!isEditable) {
        return;
      }

      const currentAnalysisMetadata = analysesMetadata.find(
        (metadata) => metadata.id === analysisID,
      );

      const formattedBarLabelWidthPercentage = Math.round(
        barLabelWidthPercentage,
      );

      const updatedAnalysesMetadata: DashboardAnalysisMetadataInput[] = Boolean(
        currentAnalysisMetadata,
      )
        ? analysesMetadata.map((metadata) =>
            metadata.id === analysisID
              ? {
                  ...metadata,
                  barLabelWidth: formattedBarLabelWidthPercentage,
                }
              : metadata,
          )
        : [
            ...analysesMetadata,
            {
              id: analysisID,
              barLabelWidth: formattedBarLabelWidthPercentage,
            },
          ];

      dispatch({
        type: DashboardActionType.SET_METADATA,
        payload: {
          analysesMetadata: updatedAnalysesMetadata,
        },
      });

      await upsertDashboard({
        dashboardProps: {
          metadataV2: {
            analysesMetadata: updatedAnalysesMetadata,
          },
        },
      });
    },
    [analysesMetadata, dispatch, isEditable, upsertDashboard],
  );

  return updateBarLabelWidthMetadata;
};
